import styled from 'styled-components';
import { Layout, Card, theme } from 'antd';

const { Header: AntHeader, Content, Sider } = Layout;

// Layout styles
export const StyledLayout = styled(Layout)`
  min-height: 100vh;
  background: ${() => {
    const { token } = theme.useToken();
    return token.colorBgLayout;
  }};

  .ant-layout {
    background: ${() => {
      const { token } = theme.useToken();
      return token.colorBgLayout;
    }};
  }
`;

export const MainLayout = styled(Layout)`
  min-height: 100vh;
  padding-left: ${props => props.theme.siderWidth}px;
  padding-top: 64px;
  transition: padding-left 0.2s ease;

  @media (max-width: 767px) {
    padding-left: 0 !important;
  }
`;

export const StyledSider = styled(Sider)`
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1001;
  border-right: 1px solid ${() => {
    const { token } = theme.useToken();
    return token.colorBorderSecondary;
  }};
  background: ${() => {
    const { token } = theme.useToken();
    return token.colorBgContainer;
  }};

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
  }

  .ant-menu {
    flex: 1;
    background: ${() => {
      const { token } = theme.useToken();
    return token.colorBgContainer;
  }};
  }

  .ant-layout-sider-trigger {
    display: none;
  }
`;

export const StyledContent = styled(Content)`
  padding: 16px;
  margin: 8px;
  margin-top: 20px;
  background: ${() => {
    const { token } = theme.useToken();
    return token.colorBgContainer;
  }};
  border-radius: ${() => {
    const { token } = theme.useToken();
    return token.borderRadiusLG;
  }}px;
  min-height: calc(100vh - 88px);

  @media (max-width: 767px) {
    padding: 8px;
    margin: 4px;
    margin-top: 12px;
    border-radius: 8px;
  }
`;

export const StyledHeader = styled(AntHeader)`
  position: fixed;
  top: 0;
  right: 0;
  left: ${props => props.theme.siderWidth}px;
  padding: 0;
  background: ${() => {
    const { token } = theme.useToken();
    return token.colorBgContainer;
  }};
  border-bottom: 1px solid ${() => {
    const { token } = theme.useToken();
    return token.colorBorderSecondary;
  }};
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  transition: left 0.2s ease;

  .header-left {
    display: flex;
    align-items: center;
    padding-left: 16px;
  }

  .header-right {
    display: flex;
    align-items: center;
    padding-right: 24px;
  }

  .trigger-button {
    padding: 0 24px;
    font-size: 18px;
    cursor: pointer;
    transition: color 0.3s;
    display: flex;
    align-items: center;
  }
`;

export const Logo = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: ${() => {
    const { token } = theme.useToken();
    return token.colorText;
  }};
  padding: 16px;
  border-bottom: 1px solid ${() => {
    const { token } = theme.useToken();
    return token.colorBorder;
  }};
`;

// Card styles
export const StyledCard = styled(Card)``;

export const PageContainer = styled.div`
  padding: 5px;
  width: 100%;
`;

// Dashboard styles
export const AuthContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${() => {
    const { token } = theme.useToken();
    return token.colorBgLayout;
  }};
`;

export const AuthCard = styled(Card)`
  width: 100%;
  max-width: 400px;
  box-shadow: ${() => {
    const { token } = theme.useToken();
    return `0 4px 12px ${token.colorBgMask}`;
  }};
  border-radius: ${() => {
    const { token } = theme.useToken();
    return token.borderRadiusLG;
  }}px;
`;

export const AuthTitle = styled.h1`
  text-align: center;
  color: ${() => {
    const { token } = theme.useToken();
    return token.colorPrimary;
  }};
  margin-bottom: 24px;
`;
